export default {
  mounted: function (el) {
    const value = el.textContent;
    const number = parseInt(value.replace(/\D/g, ""));
    el.textContent = number.toLocaleString() + value.replace(/\d/g, "");
  },
};
